import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { usePageMeta } from "../lib/usePageMeta";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PostCard from "../components/PostCard";

export default function Category() {
  const { slug } = useParams();
  const [pageTitle, setPageTitle] = useState(null);
  usePageMeta(pageTitle);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [cat, setCat] = useState(null);
  const [subCats, setSubCats] = useState([]);

  useEffect(() => {
    setLoading(true);
    api.get("/categories", { params: { only_active: true } }).then(async (r) => {
      const all = r.data;
      const found = all.find((x) => x.slug === slug);
      setCat(found);
      const isParent = found && !found.parent_slug;
      const children = isParent ? all.filter((c) => c.parent_slug === slug) : [];
      setSubCats(children);
      if (found) {
        document.title = `${found.name} — Viagens Orion`;
        setPageTitle(document.title);
        const params = isParent ? { parent: slug, limit: 200 } : { category: found.slug, limit: 200 };
        const p = await api.get("/posts", { params });
        setPosts(p.data.items || []);
        setTotal(p.data.total ?? (p.data.items || []).length);
      }
    }).finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="container-orion py-16 md:py-24 flex-1" data-testid="category-page">
        <div className="mb-10 border-b border-[#EFEAE0] pb-8">
          {cat?.parent_slug && (
            <Link to={`/categoria/${cat.parent_slug}`} className="cat-chip mb-2 inline-block hover:text-orion-purple" data-testid="breadcrumb-parent">
              ← Ver parente
            </Link>
          )}
          {!cat?.parent_slug && <div className="cat-chip mb-3">Editoria</div>}
          <h1 className="font-serif text-2xl md:text-5xl lg:text-6xl font-semibold text-orion-purple">
            {cat?.name || slug}
          </h1>
          <p className="mt-3 text-[#594A63]">{total} artigo{total !== 1 ? "s" : ""} publicado{total !== 1 ? "s" : ""}.</p>

          {subCats.length > 0 && (
            <div className="mt-8 flex flex-wrap gap-2">
              {subCats.map((s) => (
                <Link
                  key={s.id}
                  to={`/categoria/${s.slug}`}
                  className="text-xs uppercase tracking-[0.2em] font-semibold border border-[#DFD8C7] px-4 py-2 text-[#594A63] hover:border-orion-orange hover:text-orion-orange transition-colors"
                  data-testid={`sub-chip-${s.slug}`}
                >
                  {s.name}
                </Link>
              ))}
            </div>
          )}
        </div>

        {loading && <div className="text-center py-20 text-[#8A8191]">Carregando…</div>}
        {!loading && posts.length === 0 && (
          <div className="text-center py-16 text-[#8A8191]">Nenhum artigo publicado nesta editoria ainda.</div>
        )}

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-10">
          {posts.map((p) => <PostCard key={p.id} post={p} />)}
        </div>
      </main>
      <Footer />
    </div>
  );
}
